import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ChevronLeftIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/chevron-left"><path id="Icon" d="M15.1 19L8.09998 12L15.1 5" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ChevronLeftIcon;